import { render } from "./EditValidationQueue.vue?vue&type=template&id=09cc07d8&ts=true"
import script from "./EditValidationQueue.vue?vue&type=script&lang=ts"
export * from "./EditValidationQueue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__